import React from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Translate } from 'react-localize-redux';
import type { SurgeryProcedureRow } from '../types';

interface SurgeryProcedureTableProps {
  rows: SurgeryProcedureRow[];
  title: string;
}

const SurgeryProcedureTable: React.FC<SurgeryProcedureTableProps> = ({ rows, title }) => (
  <Box>
    <Typography variant="h6">{title}</Typography>
    {rows.length === 0 ? (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        <Translate id="hospital.analytics.no_data" />
      </Typography>
    ) : (
      <TableContainer component={Paper} sx={{ mt: 1 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell><Translate id="hospital.analytics.surgery.tables.procedure" /></TableCell>
              <TableCell align="right"><Translate id="hospital.analytics.surgery.tables.episodes" /></TableCell>
              <TableCell align="right"><Translate id="hospital.analytics.surgery.tables.completed" /></TableCell>
              <TableCell align="right"><Translate id="hospital.analytics.surgery.tables.cancelled" /></TableCell>
              <TableCell align="right"><Translate id="hospital.analytics.surgery.tables.median_delay" /></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.procedureKey}>
                <TableCell>{row.procedureLabel}</TableCell>
                <TableCell align="right">{row.episodeCount}</TableCell>
                <TableCell align="right">{row.completed}</TableCell>
                <TableCell align="right">{row.cancelled}</TableCell>
                <TableCell align="right">
                  {row.medianReadyToOperationDays > 0
                    ? row.medianReadyToOperationDays.toFixed(1)
                    : '—'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )}
  </Box>
);

export default SurgeryProcedureTable;
